import React from 'react';
import {
  RingIcon,
  BarIcon,
  PieIcon,
  ColumnIcon,
  LineIcon,
  RadarIcon,
  TableIcon
} from './Icons';

export const COLORS = [
  '#0088FE',
  '#00C49F',
  '#FFBB28',
  '#FF8042',
  '#571263',
  '#5be93f',
  '#81b7ad',
  '#930090',
  '#5c27a7',
  '#d5fe0b',
  '#cd0e40',
  '#864aed',
  '#800636',
  '#9b067a',
  '#2f2751',
  '#7a507c',
  '#11b3ce',
  '#3bc06b',
  '#a19748',
  '#d21d1d',
  '#e4709e',
  '#2755e1',
  '#787cd9',
  '#fc5bfa',
  '#35b1dd',
  '#9c4fcb',
  '#0b65f3',
  '#2f9061',
  '#f7613d',
  '#8bddfe',
  '#A4CF42'
];

export const ALL_PLOT_OPTIONS = [
  { id: 'anillo', label: 'Anillo' },
  { id: 'horizontalBar', label: 'Barra' },
  { id: 'pie', label: 'Circular' },
  { id: 'column', label: 'Columna' },
  { id: 'line', label: 'Línea' },
  { id: 'radar', label: 'Radar' },
  { id: 'table', label: 'Tabla' }
];

export const getAvailableOptions = (question) => {
  const { questionType, responseFormat } = question;

  // 1. Preguntas Abiertas: Solo Tabla
  if (questionType === 'open') {
    return [{ id: 'table', label: 'Tabla', icon: <TableIcon /> }];
  }

  // 2. Preguntas Estructurada: Matriz (Columna, Barra y Tabla)
  if (questionType === 'structured' && responseFormat === 'matrix') {
    return [
      { id: 'column', label: 'Columna', icon: <ColumnIcon /> },
      { id: 'horizontalBar', label: 'Barra', icon: <BarIcon /> },
      { id: 'table', label: 'Tabla', icon: <TableIcon /> }
    ];
  }

  // 3. Preguntas de Puntuación: Emojis y Estrellas (Todos menos radar)
  if (questionType === 'evaluation_scale' && (responseFormat === 'emojis' || responseFormat === 'stars')) {
    return [
      { id: 'anillo', label: 'Anillo', icon: <RingIcon /> },
      { id: 'horizontalBar', label: 'Barra', icon: <BarIcon /> },
      { id: 'pie', label: 'Circular', icon: <PieIcon /> },
      { id: 'column', label: 'Columna', icon: <ColumnIcon /> },
      { id: 'line', label: 'Línea', icon: <LineIcon /> },
      { id: 'table', label: 'Tabla', icon: <TableIcon /> }
    ];
  }

  // 4. Preguntas Diferencial Semántico: Solo Línea y Tabla
  if (questionType === 'evaluation_scale' && responseFormat === 'semantic_differential') {
    return [
      { id: 'line', label: 'Línea', icon: <LineIcon /> },
      { id: 'table', label: 'Tabla', icon: <TableIcon /> }
    ];
  }

  // 5. Preguntas por Puntos: Barra, Columna, Radar, Línea y Tabla
  if (questionType === 'evaluation_scale' && responseFormat === 'points') {
    return [
      { id: 'horizontalBar', label: 'Barra', icon: <BarIcon /> },
      { id: 'column', label: 'Columna', icon: <ColumnIcon /> },
      { id: 'radar', label: 'Radar', icon: <RadarIcon /> },
      { id: 'line', label: 'Línea', icon: <LineIcon /> },
      { id: 'table', label: 'Tabla', icon: <TableIcon /> }
    ];
  }

  // Default: Todos los gráficos
  return [
    { id: 'anillo', label: 'Anillo', icon: <RingIcon /> },
    { id: 'horizontalBar', label: 'Barra', icon: <BarIcon /> },
    { id: 'pie', label: 'Circular', icon: <PieIcon /> },
    { id: 'column', label: 'Columna', icon: <ColumnIcon /> },
    { id: 'line', label: 'Línea', icon: <LineIcon /> },
    { id: 'radar', label: 'Radar', icon: <RadarIcon /> },
    { id: 'table', label: 'Tabla', icon: <TableIcon /> }
  ];
};
